// drop-list-registry.service.ts
import { Injectable } from '@angular/core';
import { CdkDropList } from '@angular/cdk/drag-drop';

@Injectable({ providedIn: 'root' })
export class DropListRegistryService {
  private dropLists: CdkDropList[] = [];

  register(list: CdkDropList) {
    if (!this.dropLists.includes(list)) {
      this.dropLists.push(list);
    }
  }

  getAll() {
    return this.dropLists;
  }
}